/* =====================================================================
File: assets/twok-announcements.js
Mobile marquee for the announcement bar (single row, faster).
===================================================================== */
(function () {
  var mq = window.matchMedia('(max-width: 749px)');
  var LIST_SEL = '.tkc-announce-list';
  var FLAG = 'twokMarqueeInit';

  function init() {
    var list = document.querySelector(LIST_SEL);
    if (!list) return;
    if (list.dataset[FLAG] === '1') return; // avoid double init
    list.dataset[FLAG] = '1';

    // Duplicate content once for seamless loop
    list.innerHTML = list.innerHTML + list.innerHTML;

    function applyDuration() {
      // Increase or decrease speed here (px per second)
      var SPEED = 110; // ↑ faster than before
      // We duplicated the content, so one full cycle = HALF of scrollWidth
      var halfWidth = (list.scrollWidth || 1000) / 2;
      var dur = Math.max(6, Math.round(halfWidth / SPEED)); // seconds
      list.style.setProperty('--twok-marquee-duration', dur + 's');
    }

    applyDuration();
    window.addEventListener('resize', applyDuration);
  }

  function handleChange(e) {
    if (e.matches) init();
  }

  if (mq.matches) init();
  if (mq.addEventListener) mq.addEventListener('change', handleChange);
  else mq.addListener(handleChange);
})();
